import { create } from "zustand";

import { PoseLibraryTab, PoseReferenceData } from "./types";

interface PoserState {
  selectedTab: PoseLibraryTab;
  selectTab: (tab: PoseLibraryTab) => void;

  isPoseCreatorOpen: boolean;
  referencePoseFileId: string | null;
  referencePoseData: PoseReferenceData | null;
  openPoseCreatorInCreateMode: () => void;
  openPoseCreatorInEditMode: (fileId: string) => void;
  openPoseCreatorInReferencePoseMode: (pose: PoseReferenceData) => void;
  closePoseCreator: () => void;
  closePoser: () => void;
}

export const usePoserStore = create<PoserState>((set) => ({
  selectedTab: "library",
  selectTab: (tab: PoseLibraryTab) => set(() => ({ selectedTab: tab })),

  isPoseCreatorOpen: false,
  referencePoseFileId: null,
  referencePoseData: null,
  openPoseCreatorInCreateMode: () =>
    set(() => ({
      isPoseCreatorOpen: true,
    })),
  openPoseCreatorInEditMode: (fileId: string) =>
    set(() => ({
      isPoseCreatorOpen: true,
      referencePoseFileId: fileId,
    })),
  openPoseCreatorInReferencePoseMode: (poseData: PoseReferenceData) =>
    set(() => ({
      isPoseCreatorOpen: true,
      referencePoseData: poseData,
    })),
  closePoseCreator: () =>
    set(() => ({
      isPoseCreatorOpen: false,
      referencePoseData: null,
      referencePoseFileId: null,
    })),

  closePoser: () =>
    set(() => ({
      isPoseCreatorOpen: false,
    })),
}));
